<script lang="ts" setup>
defineProps<{
  text: string
}>()
</script>

<template>
  <strong class="block text-base font-medium leading-normal tracking-[-0.01em] text-main-dark">
    {{ text }}
  </strong>
</template>
